import React from "react";
import { useTranslation } from "react-i18next";
import { ShimmerDiv, ShimmerTitle } from "./ThemedShimmer";

const GridCardSkeleton = ({
  count = 6,
  columns = 2,
  cardHeight = 200,
  showHeader = true,
  className = "",
}) => {
  const { t } = useTranslation();
  const gridClass =
    columns === 3 ? "skeleton-grid skeleton-grid--cols-3" : "skeleton-grid";

  return (
    <div
      className={`row mt-2 ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-label={t("Common.LoadingCards")}
    >
      <span className="skeleton-screen-reader-only">{t("Common.LoadingCards")}</span>
      <div className={gridClass} style={{ width: "100%" }}>
        {Array.from({ length: count }, (_, index) => (
          <div className="shimmer-cont skeleton-surface p-2" key={`grid-skeleton-${index}`}>
            {showHeader && (
              <div className="d-flex align-items-center mb-2">
                <ShimmerDiv height={48} width={48} rounded={50} />
                <div className="shimmer-title ms-2 flex-grow-1">
                  <ShimmerTitle line={2} gap={6} />
                </div>
              </div>
            )}
            <ShimmerDiv height={cardHeight} width="100%" rounded={8} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridCardSkeleton;
